"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropToUpdateState = void 0;
var react_1 = require("react");
var usePropToUpdateState = function (prop, setState) {
    (0, react_1.useEffect)(function () {
        setState(prop);
    }, [setState, prop]);
};
exports.usePropToUpdateState = usePropToUpdateState;
